<template>
	<li
		v-if="isExternal"
		class="tab h100 border-bottom border-lg border-transparent display-flex align-items-center 
		position-relative cursor-pointer white-space-nowrap"
	>
		<a
			:href="link"
			target="_blank"
			:class="[{ active: isActive }, tabClasses]"
			class="padding-bottom no-decoration ink-lighter-1 hover-ink-base focus-ink-base active-ink-base"
		>
			{{ label }}
		</a>
	</li>
	<li
		v-else
		:key="link"
		:class="[{ active: isActive }, tabClasses]"
		class="h100 border-bottom border-lg border-transparent display-flex align-items-center position-relative  position-relative hover-ink-base focus-ink-base active-ink-base cursor-pointer white-space-nowrap"
	>
		<b-router-link
			:routerLinkClasses="linkClasses"
			:to="link"
			:color="isActive ? 'ink-base' : 'ink-lighter-1'"
		>
			{{ label }}
		</b-router-link>
	</li>
</template>

<script>
import BRouterLink from './RouterLink.vue';

export default {
	name: 'b-nav-tab',
	components: {
		BRouterLink
	},
	props: {
		/**
		 * Título que deve ser apresentado
		 */
		label: {
			type: String,
			required: true
		},
		/**
		 * Link para o qual a ação de click irá redirecionar
		 */
		link: {
			type: String,
			required: true
		},
		/**
		 * Quando TRUE adiciona estilização informando que o componente está ativo
		 */
		isActive: {
			type: Boolean,
			default: false
		},
		/**
		 * Quando TRUE o valor da prop link é aberto em outra aba
		 */
		isExternal: {
			type: Boolean,
			default: false
		},
		/**
		 * Indica que as tabs fazem parte do primeiro nível de navegação
		 */
		primaryNavTab: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		linkClasses: function() {
			return `router-link display-flex align-items-center no-decoration ${!this.primaryNavTab &&
				'padding-bottom-tiny'}`;
		},
		tabClasses: function() {
			return this.primaryNavTab ? 'primary-tab font-size-xbig' : 'tab font-size-big';
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@bossabox-code/design-system/css/_variables.scss';

li.active,
li:hover {
	border-bottom-color: map-get($colors, 'ink-base');
}

li.active {
	font-weight: 600;
}

.primary-tab {
	margin: 0 1.3rem;
}

.tab {
	margin-right: 2.4rem;
}
</style>

<docs>
    ```js
    <b-nav-tab 
		label="Dashboard"
		:isActive="true"
		:isExternal="false"
		link="/projects/1/dashboard"
	/>
    ```
</docs>
